import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'm13.939 13.188-1.639-2.16h.845a.729.729 0 0 0 0-1.458H11.2L9.056 6.739a1.724 1.724 0 0 0-.389-2.892V2.633a.729.729 0 0 0-1.458 0v1.214a1.724 1.724 0 0 0-.289 2.969L4.82 9.57H2.736a.729.729 0 1 0 0 1.458h.973l-1.646 2.158a.567.567 0 0 0 .106.794.563.563 0 0 0 .343.116.55.55 0 0 0 .437-.206l2.631-2.862h4.86l2.6 2.843a.566.566 0 0 0 .9-.683Zm-6-7.285a.722.722 0 0 1-.115-.028.474.474 0 0 1-.372-.459.487.487 0 1 1 .686.441.472.472 0 0 1-.2.043Zm.08 2.472 1.091 1.2H6.92Z';
const draw24px = 'M21.609,20.918,18.385,16.66h2.222a.816.816,0,0,0,0-1.632H17.15L13.2,9.806a2.485,2.485,0,0,0-.513-4.489.815.815,0,0,0,.028-.139V3.026a.816.816,0,0,0-1.632,0V5.178a.815.815,0,0,0,.028.139,2.484,2.484,0,0,0-.322,4.592l-3.9,5.119H3.2a.816.816,0,1,0,0,1.632h2.44L2.392,20.916a.544.544,0,0,0,.1.762.536.536,0,0,0,.329.112.544.544,0,0,0,.433-.214L7.776,16.66h8.481l4.485,4.914a.544.544,0,0,0,.867-.656ZM10.679,7.679a1.217,1.217,0,1,1,1.717,1.1,1.2,1.2,0,0,1-.5.113,1.147,1.147,0,0,1-.292-.059A1.2,1.2,0,0,1,10.679,7.679Zm-1.4,7.349,2.755-3,2.735,3Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const CalibrateIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'calibrate'));
CalibrateIcon.displayName = 'CalibrateIcon';
CalibrateIcon.propTypes = Icon.propTypes;
CalibrateIcon.renderIcon = props => /*#__PURE__*/React.createElement(CalibrateIcon, props);
export default CalibrateIcon;
//# sourceMappingURL=CalibrateIcon.js.map